import React from 'react';
import { Col, Form, Input, Row } from 'antd';
import { FileTextOutlined, ToolOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { TransportRouteDetailDto } from '../dto/transport';
import TransportFormSection from './TransportFormSection';

const { TextArea } = Input;

interface TransportVehicleNotesSectionProps {
  transport?: TransportRouteDetailDto | null;
  isEditMode: boolean;
}

const TransportVehicleNotesSection: React.FC<TransportVehicleNotesSectionProps> = ({
  transport,
  isEditMode,
}) => {
  const { t } = useTranslation(['transport']);
  const hasVehicleData = [
    transport?.licensePlate1,
    transport?.licensePlate2,
    transport?.driverName,
    transport?.driverPhone,
  ].some((value) => String(value ?? '').trim().length > 0);

  return (
    <TransportFormSection
      sectionKey="vehicle"
      step={5}
      icon={<ToolOutlined />}
      label={t('transport:sections.vehicleDriver')}
      summary={isEditMode && hasVehicleData ? [transport?.licensePlate1, transport?.driverName].filter(Boolean).join(' · ') : undefined}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12} xl={6}>
          <Form.Item name="licensePlate1" label={t('transport:fields.licensePlate1')} style={{ marginBottom: 0 }}>
            <Input placeholder={t('transport:placeholders.licensePlate')} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} xl={6}>
          <Form.Item name="licensePlate2" label={t('transport:fields.licensePlate2')} style={{ marginBottom: 0 }}>
            <Input placeholder={t('transport:placeholders.licensePlate')} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} xl={6}>
          <Form.Item name="driverName" label={t('transport:fields.driverName')} style={{ marginBottom: 0 }}>
            <Input placeholder={t('transport:placeholders.driverName')} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} xl={6}>
          <Form.Item name="driverPhone" label={t('transport:fields.driverPhone')} style={{ marginBottom: 0 }}>
            <Input placeholder={t('transport:placeholders.driverPhone')} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        name="notes"
        label={(
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <FileTextOutlined aria-hidden="true" />
            {t('transport:fields.notes')}
          </span>
        )}
        style={{ marginTop: 16, marginBottom: 0 }}
      >
        <TextArea rows={4} placeholder={t('transport:placeholders.notes')} />
      </Form.Item>
    </TransportFormSection>
  );
};

export default TransportVehicleNotesSection;
